import { render, staticRenderFns } from "./customerOrderAssessment.vue?vue&type=template&id=051ed30e&scoped=true&"
import script from "./customerOrderAssessment.vue?vue&type=script&lang=js&"
export * from "./customerOrderAssessment.vue?vue&type=script&lang=js&"
import style0 from "./customerOrderAssessment.vue?vue&type=style&index=0&id=051ed30e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051ed30e",
  null
  
)

export default component.exports